module.exports = __webpack_public_path__ + "static/media/webdesign-services-img1.e0649269.jpg";